/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TimesIcon = ({ className }) => {
  return (
    <svg
      className={className}
      style={{ width: '35px', height: '35px' }}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 1.66663C5.40841 1.66663 1.66675 5.40829 1.66675 9.99996C1.66675 14.5916 5.40841 18.3333 10.0001 18.3333C14.5917 18.3333 18.3334 14.5916 18.3334 9.99996C18.3334 5.40829 14.5917 1.66663 10.0001 1.66663ZM12.8001 11.9166C13.0417 12.1583 13.0417 12.5583 12.8001 12.8C12.6751 12.925 12.5167 12.9833 12.3584 12.9833C12.2001 12.9833 12.0417 12.925 11.9167 12.8L10.0001 10.8833L8.08341 12.8C7.95841 12.925 7.80008 12.9833 7.64175 12.9833C7.48342 12.9833 7.32508 12.925 7.20008 12.8C6.95842 12.5583 6.95842 12.1583 7.20008 11.9166L9.11675 9.99996L7.20008 8.08329C6.95842 7.84163 6.95842 7.44163 7.20008 7.19996C7.44175 6.95829 7.84175 6.95829 8.08341 7.19996L10.0001 9.11663L11.9167 7.19996C12.1584 6.95829 12.5584 6.95829 12.8001 7.19996C13.0417 7.44163 13.0417 7.84163 12.8001 8.08329L10.8834 9.99996L12.8001 11.9166Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
